import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppQuery } from '../use-app-query.hook';
import { DividendDistribution } from './dividend.types';

export const useDividendDistribution = ({ companyId }: { companyId: string }) => {
  const { data, isLoading } = useAppQuery({
    queryKey: [QueryKey.DIVIDEND_DISTRIBUTION, companyId],
    queryFn: () =>
      ApiService.get<DividendDistribution>({ endpoint: BackendRoute.DIVIDENDS_DISTRIBUTION }),
  });

  return { distribution: data, isLoading };
};
